import { BODY_CONFIG } from '@/components/Typography';
import { GetPageLink } from '@/utility/getLinkPage';
import { Link as ChakraUiLink } from '@chakra-ui/react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import type { CSSProperties, FC } from 'react';

import type { LinkProps } from './types';

export const Link: FC<LinkProps> = ({ href, children, withoutUrlParam = false, ...props }) => {
  const { query } = useRouter();
  return (
    <NextLink passHref href={withoutUrlParam ? href : GetPageLink(typeof href === 'string' ? href : href.href!, query)}>
      <ChakraUiLink
        _hover={{ textDecoration: 'none' }}
        color="accent03"
        style={BODY_CONFIG.Bold14 as CSSProperties}
        {...props}
      >
        {children}
      </ChakraUiLink>
    </NextLink>
  );
};

export * from './types';
